module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eceT8"))).then(() => parcelRequire('iDabs'));